import api from 'api'

const follow = {
    follow: (userId) => api().post(`/followers/${userId}`),
    unfollow: (userId) => api().delete(`/followers/${userId}`),
}

export default follow
